import React, { useState, useEffect } from "react";

import {
  Form,
  Input,
  Button,
  message,
  Space,
  Select,
  Tabs,
  Checkbox,
  Popover,
  Switch,
  Radio,
  Rate,
} from "antd";

import { InfoCircleOutlined } from "@ant-design/icons";

import { Http } from "../../Http";
import queryString from "query-string";
import styles from "./SiteSave.module.less";

const msg = [
  `系统会自动检测敏感词，若无敏感词，就会直接发布，否则需要人工审核！`,
];

const { Option } = Select;

function SiteSave({ navigate, location }) {
  const { state } = location;
  const { data, search, pagination } = state;

  const [submit, setSubmit] = useState(false);
  const [subSwitch, setSubSwitch] = useState(false);
  const [newsChecked, setNewsChecked] = useState(false);
  const [productChecked, setProductChecked] = useState(false);
  const [brandChecked, setBrandChecked] = useState(false);

  const [form] = Form.useForm();
  const { TabPane } = Tabs;

  const theme = [
    { value: "s1", key: "1号模板" },
    { value: "s2", key: "2号模板" },
    { value: "s3", key: "3号模板" },
    { value: "s4", key: "4号模板" },
    { value: "s5", key: "5号模板" },
    { value: "s6", key: "6号模板" },
    { value: "s7", key: "7号模板" },
    { value: "s8", key: "8号模板" },
    { value: "s9", key: "9号模板" },
    { value: "s10", key: "10号模板" },
  ];

  const newsRule = [
    { value: "/news/:y/:m/:d/:id.html", key: "/news/:y/:m/:d/:id.html" },
    { value: "/news/:y-:m-:d/:id.html", key: "/news/:y-:m-:d/:id.html" },
    {
      value: "/news/:y(\\w+)_:m(\\w+)_:d/:id.html",
      key: "/news/:y_:m_:d/:id.html",
    },
    { value: "/news/:id.html", key: "/news/:id.html" },
    { value: "/news-:id.html", key: "/news-:id.html" },
    { value: "/news_:id.html", key: "/news_:id.html" },
    { value: "/news:id.html", key: "/news:id.html" },
    { value: "/news/:y:m:d/:id.html", key: "/news/:y:m:d/:id.html" },
    { value: "/news-:y:m:d-:id.html", key: "/news-:y:m:d-:id.html" },
    {
      value: "/news_:y:m:d(\\w+)_:id.html",
      key: "/news_:y:m:d_:id.html",
    },
    { value: "/news/:y:m/:d/:id.html", key: "/news/:y:m/:d/:id.html" },
    { value: "/news/:y:m-:d-:id.html", key: "/news/:y:m-:d-:id.html" },
    { value: "/news/:y/:id.html", key: "/news/:y/:id.html" },
    { value: "/news/:m/:id.html", key: "/news/:m/:id.html" },
    { value: "/news/:d/:id.html", key: "/news/:d/:id.html" },
    { value: "/news/:y-:id.html", key: "/news/:y-:id.html" },
    { value: "/news/:m-:id.html", key: "/news/:m-:id.html" },
    { value: "/news/:d-:id.html", key: "/news/:d-:id.html" },
    { value: "/n/:id.html", key: "/n/:id.html" },
    { value: "/n-:id.html", key: "/n-:id.html" },
    { value: "/n_:id.html", key: "/n_:id.html" },
    { value: "/n:id.html", key: "/n:id.html" },
  ];

  const productRule = [
    { value: "/product/:y/:m/:d/:id.html", key: "/product/:y/:m/:d/:id.html" },
    { value: "/product/:y-:m-:d/:id.html", key: "/product/:y-:m-:d/:id.html" },
    {
      value: "/product/:y(\\w+)_:m(\\w+)_:d/:id.html",
      key: "/product/:y_:m_:d/:id.html",
    },
    { value: "/product/:id.html", key: "/product/:id.html" },
    { value: "/product-:id.html", key: "/product-:id.html" },
    { value: "/product_:id.html", key: "/product_:id.html" },
    { value: "/product:id.html", key: "/product:id.html" },
    { value: "/product/:y:m:d/:id.html", key: "/product/:y:m:d/:id.html" },
    { value: "/product-:y:m:d-:id.html", key: "/product-:y:m:d-:id.html" },
    {
      value: "/product_:y:m:d(\\w+)_:id.html",
      key: "/product_:y:m:d_:id.html",
    },
    { value: "/product/:y:m/:d/:id.html", key: "/product/:y:m/:d/:id.html" },
    { value: "/product/:y:m-:d-:id.html", key: "/product/:y:m-:d-:id.html" },
    { value: "/product/:y/:id.html", key: "/product/:y/:id.html" },
    { value: "/product/:m/:id.html", key: "/product/:m/:id.html" },
    { value: "/product/:d/:id.html", key: "/product/:d/:id.html" },
    { value: "/product/:y-:id.html", key: "/product/:y-:id.html" },
    { value: "/product/:m-:id.html", key: "/product/:m-:id.html" },
    { value: "/product/:d-:id.html", key: "/product/:d-:id.html" },
    { value: "/p/:id.html", key: "/p/:id.html" },
    { value: "/p-:id.html", key: "/p-:id.html" },
    { value: "/p_:id.html", key: "/p_:id.html" },
    { value: "/p:id.html", key: "/p:id.html" },
  ];

  const brandRule = [
    { value: "/brand/:id.html", key: "/brand/:id.html" },
    { value: "/brand-:id.html", key: "/brand-:id.html" },
    { value: "/brand_:id.html", key: "/brand_:id.html" },
    { value: "/brand:id.html", key: "/brand:id.html" },
    { value: "/brand/:serial/:id.html", key: "/brand/:serial/:id.html" },
    { value: "/brand_:serial(\\w+)_:id.html", key: "/brand_:serial_:id.html" },
    { value: "/brand-:serial-:id.html", key: "/brand-:serial-:id.html" },
    { value: "/brand/:serial-:id.html", key: "/brand/:serial-:id.html" },
    { value: "/brand/:serial(\\w+)_:id.html", key: "/brand/:serial_:id.html" },
    { value: "/brand-:serial/:id.html", key: "/brand-:serial/:id.html" },
    { value: "/brand-:serial:id.html", key: "/brand-:serial:id.html" },
    { value: "/firm/:serial/:id.html", key: "/firm/:serial/:id.html" },
    { value: "/firm_:serial(\\w+)_:id.html", key: "/firm_:serial_:id.html" },
    { value: "/firm-:serial-:id.html", key: "/firm-:serial-:id.html" },
    { value: "/firm/:serial-:id.html", key: "/firm/:serial-:id.html" },
    { value: "/firm/:serial(\\w+)_:id.html", key: "/firm/:serial_:id.html" },
    { value: "/firm-:serial/:id.html", key: "/firm-:serial/:id.html" },
    { value: "/brand/:alias/:id.html", key: "/brand/:alias/:id.html" },
    { value: "/brand_:alias(\\w+)_:id.html", key: "/brand_:alias_:id.html" },
    { value: "/brand-:alias-:id.html", key: "/brand-:alias-:id.html" },
    { value: "/brand/:alias-:id.html", key: "/brand/:alias-:id.html" },
    { value: "/brand/:alias(\\w+)_:id.html", key: "/brand/:alias_:id.html" },
    { value: "/brand-:alias/:id.html", key: "/brand-:alias/:id.html" },
    { value: "/brand-:alias:id.html", key: "/brand-:alias:id.html" },
    { value: "/firm/:alias/:id.html", key: "/firm/:alias/:id.html" },
    { value: "/firm_:alias(\\w+)_:id.html", key: "/firm_:alias_:id.html" },
    { value: "/firm-:alias-:id.html", key: "/firm-:alias-:id.html" },
    { value: "/firm/:alias-:id.html", key: "/firm/:alias-:id.html" },
    { value: "/firm/:alias(\\w+)_:id.html", key: "/firm/:alias_:id.html" },
    { value: "/firm-:alias/:id.html", key: "/firm-:alias/:id.html" },
  ];

  const onBack = () => {
    navigate("../", { state: { search, pagination } });
  };

  const onFinish = async (values) => {
    setSubmit(true);
    values.genSubDomain = values.genSubDomain ? 1 : 0;
    values.genSubNewsShow = values.genBrandNewsShow;
    values.genSubProductShow = values.genBrandProductShow;
    if (data) {
      values = { ...data, ...values };
    }
    let para = queryString.stringify(values);
    try {
      let parsed = await Http.post(`site/save`, {
        body: new URLSearchParams(para),
      }).json();
      if (parsed.state === "ok") {
        await message.success(parsed.message ? parsed.message : "提交成功");
        onBack();
      } else {
        await message.warn(parsed.message ? parsed.message : "提交失败");
      }
    } catch (error) {
      await message.error("接口调用错误, 错误原因:" + error.message);
    } finally {
      setSubmit(false);
    }
  };

  useEffect(() => {
    if (data) {
      if (data.genBrandNewsShow) {
        let flag = false;
        newsRule.forEach((v) => {
          if (v.value == data.genBrandNewsShow) {
            flag = true;
          }
        });
        if (!flag) {
          setNewsChecked(true);
        }
      }

      if (data.genBrandProductShow) {
        let flag = false;
        productRule.forEach((v) => {
          if (v.value == data.genBrandProductShow) {
            flag = true;
          }
        });
        if (!flag) {
          setProductChecked(true);
        }
      }

      if (data.genBrandPageHome) {
        let flag = false;
        brandRule.forEach((v) => {
          if (v.value == data.genBrandPageHome) {
            flag = true;
          }
        });
        if (!flag) {
          setBrandChecked(true);
        }
      }

      data.genSubPageHome = data.genSubPageHome ? data.genSubPageHome : "/";
      data.genSubPageAbout = data.genSubPageAbout
        ? data.genSubPageAbout
        : "/about.html";
      data.genSubNewsList = data.genSubNewsList
        ? data.genSubNewsList
        : "/news{/page:p.html}?";
      data.genSubProductList = data.genSubProductList
        ? data.genSubProductList
        : "/product{/page:p.html}?";
      data.genSubPageContact = data.genSubPageContact
        ? data.genSubPageContact
        : "/contact.html";
      data.genSubPageSitemap = data.genSubPageSitemap
        ? data.genSubPageSitemap
        : "/sitemap.xml";
      data.genSitePageHome = data.genSitePageHome ? data.genSitePageHome : "/";
      data.genSiteSitemapIndex = data.genSiteSitemapIndex
        ? data.genSiteSitemapIndex
        : "/sitemap.xml";
      data.genSiteSitemapLatest = data.genSiteSitemapLatest
        ? data.genSiteSitemapLatest
        : "/sitemap.html";
      data.genSiteNewsHome = data.genSiteNewsHome
        ? data.genSiteNewsHome
        : "/news{/list:p.html}?";
      data.genSiteNewsCate = data.genSiteNewsCate
        ? data.genSiteNewsCate
        : "/news/cate/{:id}?{/list:p.html}?";
      data.genSiteProductHome = data.genSiteProductHome
        ? data.genSiteProductHome
        : "/product{/list:p.html}?";
      data.genSiteProductCate = data.genSiteProductCate
        ? data.genSiteProductCate
        : "/product/cate/:id{/list:p.html}?";
      data.genSiteProductAlph = data.genSiteProductAlph
        ? data.genSiteProductAlph
        : "/zimu/:alph{/list:p.html}?";
      data.genSiteBrandHome = data.genSiteBrandHome
        ? data.genSiteBrandHome
        : "/brand{/list:p.html}?";
      data.genSiteBrandCate = data.genSiteBrandCate
        ? data.genSiteBrandCate
        : "/brand/cate/:id{/list:p.html}?";
      data.genSiteAreaHome = data.genSiteAreaHome
        ? data.genSiteAreaHome
        : "/area{/list:p.html}?";
      data.genSiteAreaCate = data.genSiteAreaCate
        ? data.genSiteAreaCate
        : "/area/cate/:id{/list:p.html}?";
      data.genSitePageAbout = data.genSitePageAbout
        ? data.genSitePageAbout
        : "/about.html";
      data.genSitePageContact = data.genSitePageContact
        ? data.genSitePageContact
        : "/contact.html";
      data.genSitePageService = data.genSitePageService
        ? data.genSitePageService
        : "/service.html";
      data.genSitePageAgreement = data.genSitePageAgreement
        ? data.genSitePageAgreement
        : "/agreement.html";
      data.genSitePageCopyright = data.genSitePageCopyright
        ? data.genSitePageCopyright
        : "/copyright.html";
      data.genBrandPageAbout = data.genBrandPageAbout
        ? data.genBrandPageAbout
        : "/brand:id/about.html";
      data.genBrandNewsList = data.genBrandNewsList
        ? data.genBrandNewsList
        : "/brand:id/news{/page:p.html}?";
      data.genBrandProductList = data.genBrandProductList
        ? data.genBrandProductList
        : "/brand:id/product{/page:p.html}?";
      data.genBrandPageContact = data.genBrandPageContact
        ? data.genBrandPageContact
        : "/brand:id/contact.html";
      data.genBrandPageSitemap = data.genBrandPageSitemap
        ? data.genBrandPageSitemap
        : "/sitemap/:id.xml";

      setSubSwitch(Number(data.genSubDomain) === 1);
      form.setFieldsValue(data);
    } else {
      setNewsChecked(false);
      setProductChecked(false);
      setBrandChecked(false);

      let para = {};
      para.genSubPageHome = "/";
      para.genSubPageAbout = "/about.html";
      para.genSubNewsList = "/news{/page:p.html}?";
      para.genSubProductList = "/product{/page:p.html}?";
      para.genSubPageContact = "/contact.html";
      para.genSubPageSitemap = "/sitemap.xml";
      para.genSitePageHome = "/";
      para.genSiteSitemapIndex = "/sitemap.xml";
      para.genSiteSitemapLatest = "/sitemap.html";
      para.genSiteNewsHome = "/news{/list:p.html}?";
      para.genSiteNewsCate = "/news/cate/{:id}?{/list:p.html}?";
      para.genSiteProductHome = "/product{/list:p.html}?";
      para.genSiteProductCate = "/product/cate/:id{/list:p.html}?";
      para.genSiteProductAlph = "/zimu/:alph{/list:p.html}?";
      para.genSiteBrandHome = "/brand{/list:p.html}?";
      para.genSiteBrandCate = "/brand/cate/:id{/list:p.html}?";
      para.genSiteAreaHome = "/area{/list:p.html}?";
      para.genSiteAreaCate = "/area/cate/:id{/list:p.html}?";
      para.genSitePageAbout = "/about.html";
      para.genSitePageContact = "/contact.html";
      para.genSitePageService = "/service.html";
      para.genSitePageAgreement = "/agreement.html";
      para.genSitePageCopyright = "/copyright.html";
      para.genBrandPageAbout = "/brand:id/about.html";
      para.genBrandNewsList = "/brand:id/news{/page:p.html}?";
      para.genBrandProductList = "/brand:id/product{/page:p.html}?";
      para.genBrandPageContact = "/brand:id/contact.html";
      para.genBrandPageSitemap = "/sitemap/:id.xml";

      form.resetFields();
      form.setFieldsValue(para);
    }
  }, [data]);

  return (
    <div className={styles.SiteSave}>
      <Tabs type="card">
        <TabPane tab="主站设置" key="1" forceRender={true}>
          <Form
            labelCol={{ span: 2 }}
            wrapperCol={{ span: 9 }}
            form={form}
            onFinish={onFinish}
          >
            <Form.Item
              label="站点名称"
              name="name"
              rules={[{ required: true, message: "请输入站点名称" }]}
            >
              <Input placeholder="请输入站点名称" />
            </Form.Item>

            <Form.Item
              label="站点标题"
              name="title"
              rules={[{ required: true, message: "请输入站点标题" }]}
            >
              <Input placeholder="请输入站点标题" />
            </Form.Item>

            <Form.Item
              label="站点域名"
              name="host"
              rules={[{ required: true, message: "请输入站点域名" }]}
            >
              <Input placeholder="请输入站点域名" />
            </Form.Item>

            <Form.Item
              label="站点链接"
              name="url"
              rules={[{ required: true, message: "请输入站点链接" }]}
            >
              <Input placeholder="请输入站点链接" />
            </Form.Item>

            <Form.Item
              label="关键词"
              name="keyword"
              rules={[{ required: true, message: "请输入关键词,用逗号隔开" }]}
            >
              <Input placeholder="请输入关键词,用逗号隔开" />
            </Form.Item>

            <Form.Item
              label="简介"
              name="description"
              rules={[{ required: true, message: "请输入简介" }]}
            >
              <Input.TextArea placeholder="请输入简介" />
            </Form.Item>

            <Form.Item label="新闻规则" required>
              <Form.Item
                name="genBrandNewsShow"
                rules={[{ required: true, message: "请选择或输入新闻规则" }]}
                style={{ marginBottom: "5px" }}
              >
                {newsChecked ? (
                  <Input placeholder="请输入新闻规则" />
                ) : (
                    <Select placeholder="请选择新闻规则" allowClear>
                      {newsRule.map((value) => (
                        <Option key={value.key} value={value.value}>
                          {value.key}
                        </Option>
                      ))}
                    </Select>
                  )}
              </Form.Item>
              <div className={styles.formTips}>
                <Checkbox
                  checked={newsChecked}
                  onChange={() => setNewsChecked(!newsChecked)}
                >
                  自定义
                </Checkbox>
                <Popover
                  content={
                    <div>
                      <p style={{ marginBottom: "5px", fontSize: "12px" }}>
                        1. 必须以/开头，如/news
                      </p>
                      <p style={{ marginBottom: "5px", fontSize: "12px" }}>
                        2.使用的变量总共有:y (年)，:m (月)，:d (日)，:id (编号)
                      </p>
                      <p style={{ marginBottom: "5px", fontSize: "12px" }}>
                        3.编号不可省略，其他可省略
                      </p>
                    </div>
                  }
                  title="使用提醒"
                  trigger="hover"
                >
                  <InfoCircleOutlined />
                </Popover>
              </div>
            </Form.Item>

            <Form.Item label="产品规则" required>
              <Form.Item
                name="genBrandProductShow"
                rules={[{ required: true, message: "请选择或输入产品规则" }]}
                style={{ marginBottom: "5px" }}
              >
                {productChecked ? (
                  <Input placeholder="请输入产品规则" />
                ) : (
                    <Select placeholder="请选择产品规则" allowClear>
                      {productRule.map((value) => (
                        <Option key={value.key} value={value.value}>
                          {value.key}
                        </Option>
                      ))}
                    </Select>
                  )}
              </Form.Item>
              <div className={styles.formTips}>
                <Checkbox
                  checked={productChecked}
                  onChange={() => setProductChecked(!productChecked)}
                >
                  自定义
                </Checkbox>
                <Popover
                  content={
                    <div>
                      <p style={{ marginBottom: "5px", fontSize: "12px" }}>
                        1. 必须以/开头，如/news
                      </p>
                      <p style={{ marginBottom: "5px", fontSize: "12px" }}>
                        2.使用的变量总共有:y (年)，:m (月)，:d (日)，:id (编号)
                      </p>
                      <p style={{ marginBottom: "5px", fontSize: "12px" }}>
                        3.编号不可省略，其他可省略
                      </p>
                    </div>
                  }
                  title="使用提醒"
                  trigger="hover"
                >
                  <InfoCircleOutlined />
                </Popover>
              </div>
            </Form.Item>

            <Form.Item label="品牌规则" required>
              <Form.Item
                name="genBrandPageHome"
                rules={[{ required: true, message: "请选择或输入品牌规则" }]}
                style={{ marginBottom: "5px" }}
              >
                {brandChecked ? (
                  <Input placeholder="请输入品牌规则" />
                ) : (
                    <Select placeholder="请选择品牌规则" allowClear>
                      {brandRule.map((value) => (
                        <Option key={value.key} value={value.value}>
                          {value.key}
                        </Option>
                      ))}
                    </Select>
                  )}
              </Form.Item>
              <div className={styles.formTips}>
                <Checkbox
                  checked={brandChecked}
                  onChange={() => setBrandChecked(!brandChecked)}
                >
                  自定义
                </Checkbox>
                <Popover
                  content={
                    <div>
                      <p style={{ marginBottom: "5px", fontSize: "12px" }}>
                        1. 必须以/开头，如/news
                      </p>
                      <p style={{ marginBottom: "5px", fontSize: "12px" }}>
                        2.使用的变量总共有:y (年)，:m (月)，:d (日)，:id (编号)
                      </p>
                      <p style={{ marginBottom: "5px", fontSize: "12px" }}>
                        3.编号不可省略，其他可省略
                      </p>
                    </div>
                  }
                  title="使用提醒"
                  trigger="hover"
                >
                  <InfoCircleOutlined />
                </Popover>
              </div>
            </Form.Item>

            <Form.Item
              label="站点模板"
              name="skin"
              rules={[{ required: true, message: "请选择站点模板" }]}
            >
              <Select placeholder="请选择站点模板" allowClear>
                {theme.map((value) => (
                  <Option key={value.key} value={value.value}>
                    {value.key}
                  </Option>
                ))}
              </Select>
            </Form.Item>

            <Form.Item
              label="顶部LOGO"
              name="logoTopUrl"
              rules={[{ required: true, message: "请输入顶部LOGO" }]}
            >
              <Input placeholder="请输入顶部LOGO" />
            </Form.Item>

            <Form.Item
              label="底部LOGO"
              name="logoEndUrl"
              rules={[{ required: true, message: "请输入底部LOGO" }]}
            >
              <Input placeholder="请输入底部LOGO" />
            </Form.Item>

            <Form.Item
              label="站点ICO"
              name="faviconUrl"
              rules={[{ required: true, message: "请输入站点ICO" }]}
            >
              <Input placeholder="请输入站点ICO" />
            </Form.Item>

            <Form.Item
              label="网站首页"
              name="genSitePageHome"
              rules={[{ required: true, message: "请输入网站首页链接" }]}
            >
              <Input placeholder="请输入网站首页链接" />
            </Form.Item>

            <Form.Item
              label="网站地图"
              name="genSiteSitemapIndex"
              rules={[{ required: true, message: "请输入网站地图链接" }]}
            >
              <Input placeholder="请输入网站地图链接" />
            </Form.Item>

            <Form.Item
              label="最近更新"
              name="genSiteSitemapLatest"
              rules={[{ required: true, message: "请输入最近更新链接" }]}
            >
              <Input placeholder="请输入最近更新链接" />
            </Form.Item>

            <Form.Item
              label="新闻中心"
              name="genSiteNewsHome"
              rules={[{ required: true, message: "请输入新闻中心链接" }]}
            >
              <Input placeholder="请输入新闻中心链接" />
            </Form.Item>

            <Form.Item
              label="新闻分类"
              name="genSiteNewsCate"
              rules={[{ required: true, message: "请输入新闻分类链接" }]}
            >
              <Input placeholder="请输入新闻分类链接" />
            </Form.Item>

            <Form.Item
              label="产品中心"
              name="genSiteProductHome"
              rules={[{ required: true, message: "请输入产品中心链接" }]}
            >
              <Input placeholder="请输入产品中心链接" />
            </Form.Item>

            <Form.Item
              label="产品分类"
              name="genSiteProductCate"
              rules={[{ required: true, message: "请输入产品分类链接" }]}
            >
              <Input placeholder="请输入产品分类链接" />
            </Form.Item>

            <Form.Item
              label="产品索引"
              name="genSiteProductAlph"
              rules={[{ required: true, message: "请输入产品索引链接" }]}
            >
              <Input placeholder="请输入产品索引链接" />
            </Form.Item>

            <Form.Item
              label="品牌中心"
              name="genSiteBrandHome"
              rules={[{ required: true, message: "请输入品牌中心链接" }]}
            >
              <Input placeholder="请输入品牌中心链接" />
            </Form.Item>

            <Form.Item
              label="品牌分类"
              name="genSiteBrandCate"
              rules={[{ required: true, message: "请输入品牌分类链接" }]}
            >
              <Input placeholder="请输入品牌分类链接" />
            </Form.Item>

            <Form.Item
              label="地区中心"
              name="genSiteAreaHome"
              rules={[{ required: true, message: "请输入地区中心链接" }]}
            >
              <Input placeholder="请输入地区中心链接" />
            </Form.Item>

            <Form.Item
              label="地区分类"
              name="genSiteAreaCate"
              rules={[{ required: true, message: "请输入地区分类链接" }]}
            >
              <Input placeholder="请输入地区分类链接" />
            </Form.Item>

            <Form.Item
              label="关于我们"
              name="genSitePageAbout"
              rules={[{ required: true, message: "请输入关于我们链接" }]}
            >
              <Input placeholder="请输入关于我们链接" />
            </Form.Item>

            <Form.Item
              label="联系我们"
              name="genSitePageContact"
              rules={[{ required: true, message: "请输入联系我们链接" }]}
            >
              <Input placeholder="请输入联系我们链接" />
            </Form.Item>

            <Form.Item
              label="招商服务"
              name="genSitePageService"
              rules={[{ required: true, message: "请输入招商服务链接" }]}
            >
              <Input placeholder="请输入招商服务链接" />
            </Form.Item>

            <Form.Item
              label="使用协议"
              name="genSitePageAgreement"
              rules={[{ required: true, message: "请输入使用协议链接" }]}
            >
              <Input placeholder="请输入使用协议链接" />
            </Form.Item>

            <Form.Item
              label="版权所有"
              name="genSitePageCopyright"
              rules={[{ required: true, message: "请输入版权所有链接" }]}
            >
              <Input placeholder="请输入版权所有链接" />
            </Form.Item>

            <Form.Item label="备案号" name="icp">
              <Input placeholder="请输入备案号" />
            </Form.Item>

            <Form.Item label="头部代码" name="head">
              <Input.TextArea placeholder="请输入头部代码" />
            </Form.Item>

            <Form.Item label="尾部代码" name="script">
              <Input.TextArea placeholder="请输入尾部代码" />
            </Form.Item>

            <Form.Item label="开启子域名" name="genSubDomain">
              <Switch
                checked={subSwitch}
                onChange={() => setSubSwitch(!subSwitch)}
              />
            </Form.Item>

            <Form.Item
              label="二级域名字段"
              name="genSubField"
              rules={[{ required: true, message: "请选择二级域名字段" }]}
            >
              <Select placeholder="请选择二级域名字段" allowClear>
                <Option value="id">用品牌ID做二级域名</Option>
                <Option value="alias">用品牌英文名做二级域名</Option>
                <Option value="serial">用品牌序列号做二级域名</Option>
              </Select>
            </Form.Item>

            <Form.Item label="星级" name="level">
              <Rate />
            </Form.Item>

            <Form.Item
              label="状态"
              name="status"
              rules={[{ required: true, message: "请选择状态" }]}
            >
              <Radio.Group>
                <Radio value={0}>禁止</Radio>
                <Radio value={1}>正常</Radio>
              </Radio.Group>
            </Form.Item>

            <Form.Item wrapperCol={{ offset: 2 }}>
              <Space>
                <Button
                  type="primary"
                  disabled={submit}
                  loading={submit}
                  htmlType="submit"
                >
                  提交
                </Button>
                <Button htmlType="button" onClick={onBack}>
                  返回
                </Button>
              </Space>
            </Form.Item>
          </Form>
        </TabPane>
        <TabPane tab="品牌链接设置" key="2" forceRender={true}>
          <Form
            labelCol={{ span: 2 }}
            wrapperCol={{ span: 9 }}
            form={form}
            onFinish={onFinish}
          >
            <Form.Item
              label="关于我们"
              name="genBrandPageAbout"
              rules={[{ required: true, message: "请输入关于我们链接" }]}
            >
              <Input placeholder="请输入关于我们链接" />
            </Form.Item>

            <Form.Item
              label="新闻列表"
              name="genBrandNewsList"
              rules={[{ required: true, message: "请输入新闻列表链接" }]}
            >
              <Input placeholder="请输入新闻列表链接" />
            </Form.Item>

            <Form.Item
              label="产品列表"
              name="genBrandProductList"
              rules={[{ required: true, message: "请输入产品列表链接" }]}
            >
              <Input placeholder="请输入产品列表链接" />
            </Form.Item>

            <Form.Item
              label="联系我们"
              name="genBrandPageContact"
              rules={[{ required: true, message: "请输入联系我们链接" }]}
            >
              <Input placeholder="请输入联系我们链接" />
            </Form.Item>

            <Form.Item
              label="站点地图"
              name="genBrandPageSitemap"
              rules={[{ required: true, message: "请输入站点地图链接" }]}
            >
              <Input placeholder="请输入站点地图链接" />
            </Form.Item>

            <Form.Item wrapperCol={{ offset: 2 }}>
              <Space>
                <Button
                  type="primary"
                  disabled={submit}
                  loading={submit}
                  htmlType="submit"
                >
                  提交
                </Button>
                <Button htmlType="button" onClick={onBack}>
                  返回
                </Button>
              </Space>
            </Form.Item>
          </Form>
        </TabPane>
        <TabPane tab="子站链接设置" key="3" forceRender={true}>
          <Form
            labelCol={{ span: 2 }}
            wrapperCol={{ span: 9 }}
            form={form}
            onFinish={onFinish}
          >
            <Form.Item
              label="网站首页"
              name="genSubPageHome"
              rules={[{ required: true, message: "请输入网站首页链接" }]}
            >
              <Input placeholder="请输入网站首页链接" />
            </Form.Item>
            <Form.Item
              label="关于我们"
              name="genSubPageAbout"
              rules={[{ required: true, message: "请输入关于我们链接" }]}
            >
              <Input placeholder="请输入关于我们链接" />
            </Form.Item>
            <Form.Item
              label="新闻列表"
              name="genSubNewsList"
              rules={[{ required: true, message: "请输入新闻列表链接" }]}
            >
              <Input placeholder="请输入新闻列表链接" />
            </Form.Item>
            <Form.Item
              label="产品列表"
              name="genSubProductList"
              rules={[{ required: true, message: "请输入产品列表链接" }]}
            >
              <Input placeholder="请输入产品列表链接" />
            </Form.Item>
            <Form.Item
              label="联系我们"
              name="genSubPageContact"
              rules={[{ required: true, message: "请输入联系我们链接" }]}
            >
              <Input placeholder="请输入联系我们链接" />
            </Form.Item>
            <Form.Item
              label="百度地图"
              name="genSubPageSitemap"
              rules={[{ required: true, message: "请输入百度地图链接" }]}
            >
              <Input placeholder="请输入百度地图链接" />
            </Form.Item>
            <Form.Item wrapperCol={{ offset: 2 }}>
              <Space>
                <Button
                  type="primary"
                  disabled={submit}
                  loading={submit}
                  htmlType="submit"
                >
                  提交
                </Button>
                <Button htmlType="button" onClick={onBack}>
                  返回
                </Button>
              </Space>
            </Form.Item>
          </Form>
        </TabPane>
      </Tabs>
    </div>
  );
}

export default SiteSave;
